import React, { memo } from 'react';

import cx from 'classnames';
import { equals, reduce } from 'ramda';

import Table from 'components/shared/Table';
import useElementSize from 'hooks/useElementSize';
import i18n from 'i18n';
import { isNotDefined } from 'utils/ramda';

import { useLayoutHeight } from '../../../functions';
import TemplatePage from '../../TemplatePage';
import { useTravelBriefTable } from './functions';
import s from './index.module.css';
import { ITableProps } from './types';

export const RecursiveTravelBrief = (props: any) => {
  const { header } = props;
  const [containerRef, containerSize] = useElementSize<HTMLDivElement>();

  return (
    <TemplatePage className={s.templatePage}>
      <div ref={containerRef} style={{ height: '850px' }}>
        <div className={s.header}>{header}</div>
        <BlockTarget size={containerSize} {...props} />
      </div>
    </TemplatePage>
  );
};

export const BlockTarget = ({ blocks, columns, isLastPage, onReady, onFail, size, depsForRerender }: any) => {
  const spaceRef = useLayoutHeight({
    maxHeight: size.height,
    ignore: !isLastPage,
    blocks,
    onReady,
    onFail,
    depsForRerender,
  });

  return (
    <div ref={spaceRef}>
      {/*@ts-ignore*/}
      <Table
        theadClassName={cx(s.thead, 'custom-manifest-thead')}
        tableClassName={cx(s.table, 'custom-manifest-table')}
        tableWrapperClassName={cx(s.tableWrapper)}
        columns={columns}
        data={blocks}
        withFixSizedColumns
      />
    </div>
  );
};

// monitor dependencies for memoizing if new props will appear
export const MemoizedRecursiveSafariTableBrief = memo(RecursiveTravelBrief, (prevProps, nextProps) => {
  return (
    equals(prevProps.blocks, nextProps.blocks) &&
    equals(prevProps.columns, nextProps.columns) &&
    prevProps.depsForRerender === nextProps.depsForRerender &&
    prevProps.isLastPage === nextProps.isLastPage
  );
});

export const TravelBriefTable = ({ onReady }: ITableProps) => {
  const { pages, columns, handleReady, handleFail } = useTravelBriefTable({ onReady });
  //@ts-ignore
  if (isNotDefined(pages)) return null;

  return (
    <>
      {pages.map((p, i) => {
        const activitiesAmount = reduce((acc, block) => acc + block.activities.length, 0, p);

        return (
          <MemoizedRecursiveSafariTableBrief
            key={i}
            onReady={handleReady}
            onFail={handleFail}
            header={i18n.t('proposal_content.pdf.itinerary_overview')}
            columns={columns}
            blocks={p}
            isLastPage={i === pages.length - 1}
            depsForRerender={activitiesAmount}
          />
        );
      })}
    </>
  );
};
